import { BaseWidget, OptionalColumnType } from './definition.scorecard.model';
import { MetricTrendChartOptions } from './metric-trend-chart-options.model';
import { OverallScoreGridOptions } from './overall-score-grid-options.model';
import { ScorecardGridOptions } from './scorecard-grid-options.model';

export enum TemplateMode {
    MANAGER = 'manager',
    PERFORMER = 'performer',
}

export enum GridType {
    Rank_View = 'rankView',
    Contribution_View = 'contributionView',
    Direct_Reports_View = 'directReportsView',
}

export enum WidgetType {
    SCORECARD_GRID = 1,
    FYI_GRID,
    OVERALL_SCORE_GRID,
    RANKINGS_GRID,
    COMPENSATION_CONDITION,
    COMPENSATION_QUALIFIERS,
    COMPENSATION_MODIFIERS,
    COMPENSATION_BONUS,
    METRIC_TREND_CHART,
    YOUR_TEAM,
}

export enum ScorecardGridType {
    MANAGER = 'manager',
    DIRECT_REPORTS = 'directReports',
}

export interface ScorecardGridDirectType {
    gridType: GridType;
    isDefault: boolean;
    headerColour: string;
}

export interface ColumnNameOverride {
    columnType: OptionalColumnType;
    name: string;
    textId: number;
}

export interface Widget<
    TOptions =
        | ScorecardGridOptions
        | OverallScoreGridOptions
        | MetricTrendChartOptions,
> extends BaseWidget {
    slideBarColour: string;
    identifier: string;
    widgetType: WidgetType;
    options: TOptions;
}

export interface LayoutSize {
    breakpoint: number;
    width: string;
}

export interface Layout {
    itemType: 'container' | 'widget';
    identifier: string;
    displayOrder: number;
    sizes: LayoutSize[];
    children: Layout[];
}

export interface TemplateDefinition {
    identifier: string;
    mode: TemplateMode;
    containerColour: string;
    widgets: Widget[];
    layouts: Layout[];
}
